import { FC } from 'react'

import { FF, FormType, RadioGroup, TextareaInput } from 'ui/components'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { QuestionnaireDemo } from '../../../../../../types'
import * as SC from '../../../../style'

export const Questions: FC<{ formApi: FormType<QuestionnaireDemo> }> = ({ formApi }) => {
  return (
    <>
      <FormRow>
        <Col>
          <SC.SecondText>
            Review all POS Transactions for out-of-state merchants and IATs. (Out of State and/or suspicious name
            requires internet search and/or communication with the customer)
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="posTransactionsReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            The business is unable to produce satisfactory documentation or evidence to demonstrate that it is duly
            licensed and operating consistently with state law.
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="produceDulyDocumentationUnable"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <SC.SecondText>
            A Secretary of State and state marijuana database search is conducted and compared to the search performed
            during the prior quarterly/annual HRR for any change in license status. If customers have surrendered a
            license, sold a license, acquired more licenses, or have a notice of license revocation, documentation of
            such is requested from the customer. Internet research is performed for an extra layer of due diligence
            related to possible enforcement actions. If the information is not available on the state marijuana database
            search or if additional licenses have been acquired, the analyst will request current licenses from the
            customer.
          </SC.SecondText>
        </Col2x>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            The business, its owner(s), manager(s), or other related parties are, or have been, subject to an
            enforcement action by the state or local authorities responsible for administering orenforcing
            marijuana-related laws or regulations.
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="subjectEnforcementActions"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>Review suspicious cash withdrawal activity for immediate or prior deposits</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="suspiciousCashWithdrawalsReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>Check for consumer accounts held by account owners/signers</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="consumerAccountsCheck"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>Review deposit/withdrawal activity for repetitive $10,000 transactions</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="depositWithdrawalActivityRepetitiveReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>Secretary of State search to verify the business is in good standing</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="businessGoodStandingVerification"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            State Marijuana Database search (Request current licenses from customer when necessary)
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="mjDatabaseSearch"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>Internet search on the business, its owner(s), manager(s), and signer(s)</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="businessInternetSearch"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            Internet search for suspicious unknown merchant ACH items (checking for equipment supplier or shipping
            service)
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="suspiciousMerchantInternetSearch"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            Review of publicly available sources and databases about the business, its owner(s), manager(s), or other
            related parties, reveal negative information, such as criminal record, involvement in the illegal purchase
            or sale of drugs, violence, or other potential connections with illicit activity. (Complete the Enhanced Due
            Diligence Exception Log)
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="adverseMediaReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="adverseMediaComments"
            children={(field) => (
              <FF field={field} label="Comments" input={(p) => <TextareaInput maxLength={5000} {...p} />} />
            )}
          />
        </Col2x>
      </FormRow>
    </>
  )
}
